function TemplatePointers(){
    return(
        <>
            <h1 className="text-2xl mt-8 font-bold">PT Sungai Mas Trans</h1>
            <p className="py-2 mt-4">✓ Jl. Pesapen Selatan No 2. 2/A</p>
            <p className="py-2 mt-4">✓ Surabaya, Indonesia</p>
        </>
    )
}

export default TemplatePointers
